import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { getWhitelabelConfig } from 'core/whitelabel';

import DocumentHead from 'legacyComponents/documentHead';

import Header from 'apps/components/header/header';

import { SinglePageMicroSite } from 'apps/microSite/singlePage/index';
import { StorySinglePageMicroSite } from 'apps/microSite/storySinglePage/index';
import { MicroSiteLanding } from 'apps/microSite/pages/landing';

@withNamespaces()
@inject('routerStore')
@observer
export class MicroSite extends React.Component {
  render() {
    const { routerStore } = this.props;
    const whitelabelConfig = getWhitelabelConfig();
    if (
      Object.keys(whitelabelConfig.pages).length === 1 &&
      !whitelabelConfig.pages.home.storySpace
    ) {
      return <SinglePageMicroSite />;
    }
    const spaceType = whitelabelConfig.pages.home.storySpace.startsWith('@')
      ? 'profile'
      : 'initiative';

    if (
      whitelabelConfig.id !== 'viralresponse' &&
      whitelabelConfig.pages?.home?.storySpace
    ) {
      return (
        <StorySinglePageMicroSite
          whitelabelConfig={whitelabelConfig}
          route={routerStore.route}
          params={
            new Map(
              Object.entries({
                [spaceType]: whitelabelConfig.pages.home.storySpace,
                slug: whitelabelConfig.pages.home.storySlug,
              }),
            )
          }
        />
      );
    }
    return (
      <>
        <DocumentHead
          title={whitelabelConfig.shortTitle || whitelabelConfig.title}
          description={whitelabelConfig.description}
          imagePath={whitelabelConfig.logo}
        />
        <Header />
        <MicroSiteLanding
          whitelabelConfig={whitelabelConfig}
          route={routerStore.route}
          params={
            new Map(
              Object.entries({
                [spaceType]: whitelabelConfig.pages.home.storySpace,
                slug: whitelabelConfig.pages.home.storySlug,
              }),
            )
          }
        />
      </>
    );
  }
}

MicroSite.propTypes = {
  params: PropTypes.object,
  routeName: PropTypes.string,
  routerStore: PropTypes.object,
};
